import GetLoading from "../../../share/getLoading";
import "../../../styles/Home-module.css";
import "./ApprovalManangments.css";
// ApprovalHierarchyManagement.js - Complete Fixed Version for Edit
import React, { useEffect, useRef, useState, useCallback } from "react";
import debounce from "lodash.debounce";
import {
  PlusCircleOutlined,
  EditFilled,
  CloseOutlined,
  SearchOutlined,
  ReloadOutlined,
  UserOutlined,
  ApartmentOutlined,
  BranchesOutlined,
} from "@ant-design/icons";
import {
  Table,
  Button,
  Space,
  Tag,
  Popconfirm,
  message,
  Input,
  Select,
  Modal,
  Form,
  Switch,
  Avatar,
  Spin,
  Tabs,
  InputNumber,
} from "antd";
import { request } from "../../../share/request";
import { boxHeader, boxHeaderTagText } from "../../../styles/boxShadow";

import { getCurrentUser } from "../../../share/getProfile";
import { formateDateSystem, linkPath } from "../../../share/helper";

const { Option } = Select;
const { TabPane } = Tabs;

const ApprovalHierarchyManagement = () => {
  const getProfile = getCurrentUser();
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hierarchyList, setHierarchyList] = useState([]);
  const [exceptionList, setExceptionList] = useState([]);
  const [activeTab, setActiveTab] = useState("hierarchy");
  
  // Filters
  const [filterParam, setFilterParam] = useState({
    search: "",
    status: "all",
  });
  const [txtSearch, setTxtSearch] = useState("");
  
  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState("hierarchy");
  const [editingId, setEditingId] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingApprovers, setLoadingApprovers] = useState(false);
  const [loadingModalOpen, setLoadingModalOpen] = useState(false);
  const [form] = Form.useForm();
  
  // Store the initial data for edit
  const [editInitialData, setEditInitialData] = useState(null);

  // Helper function to get full image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    if (imagePath.includes(linkPath)) {
      return imagePath;
    }
    return linkPath + (imagePath.startsWith('/') ? imagePath : '/' + imagePath);
  };

  // Get approval hierarchy list
  const getHierarchyList = async () => {
    setLoading(true);
    try {
      const param = new URLSearchParams();
      param.append("org_code", getProfile.org_code);
      
      if (filterParam.search) {
        param.append("search", filterParam.search);
      }
      
      if (filterParam.status !== "all") {
        param.append("is_active", filterParam.status === "active" ? 1 : 0);
      }
      
      const res = await request("approval-hierarchy?" + param.toString(), "get", {});
      console.log("Hierarchy response:", res);
      
      if (res && res.success) {
        setHierarchyList(res.data || []);
      } else if (res && res.data) {
        setHierarchyList(res.data || []);
      } else {
        setHierarchyList([]);
      }
    } catch (error) {
      console.error("Error fetching hierarchy:", error);
      message.error("មិនអាចទាញយកទិន្នន័យបានទេ");
      setHierarchyList([]);
    } finally {
      setLoading(false);
    }
  };

  // Get route exceptions list
  const getExceptionList = async () => {
    setLoading(true);
    try {
      const param = new URLSearchParams();
      param.append("org_code", getProfile.org_code);
      
      if (filterParam.search) {
        param.append("search", filterParam.search);
      }
      
      if (filterParam.status !== "all") {
        param.append("is_active", filterParam.status === "active" ? 1 : 0);
      }
      
      const res = await request("approval-route-exceptions?" + param.toString(), "get", {});
      console.log("Exceptions response:", res);
      
      if (res && res.success) {
        setExceptionList(res.data || []);
      } else if (res && res.data) {
        setExceptionList(res.data || []);
      } else {
        setExceptionList([]);
      }
    } catch (error) {
      console.error("Error fetching exceptions:", error);
      message.error("មិនអាចទាញយកទិន្នន័យបានទេ");
      setExceptionList([]);
    } finally {
      setLoading(false);
    }
  };

  // Load data when tab or filter changes
  useEffect(() => {
    if (activeTab === "hierarchy") {
      getHierarchyList();
    } else {
      getExceptionList();
    }
  }, [filterParam, activeTab]);

  // Load departments
  const loadDepartments = async () => {
    setLoadingDepartments(true);
    try {
      const param = new URLSearchParams({ org_code: getProfile.org_code });
      const res = await request("departmentall?" + param.toString(), "get", {});
      
      let deptList = [];
      if (res && res.listdepartment && Array.isArray(res.listdepartment)) {
        deptList = res.listdepartment;
      } else if (res && res.data && Array.isArray(res.data)) {
        deptList = res.data;
      } else if (res && Array.isArray(res)) {
        deptList = res;
      }
      
      const formattedDepartments = deptList.map(dept => ({
        id: dept.code,
        code: dept.code,
        name: dept.department_name || dept.name,
      }));
      
      setDepartments(formattedDepartments);
      return formattedDepartments;
    } catch (error) {
      console.log("Error loading departments:", error);
      message.error("មិនអាចទាញយកនាយកដ្ឋានបានទេ");
      return [];
    } finally {
      setLoadingDepartments(false);
    }
  };

  // Load users (for route exceptions)
  const loadUsers = async (search = "") => {
    setLoadingUsers(true);
    try {
      const param = new URLSearchParams({
        search: search,
        org_code: getProfile.org_code,
      });
      
      const res = await request(`lettersjoiner?${param.toString()}`, "get", {});
      
      if (res && res.api_server_list_joiner) {
        const userList = res.api_server_list_joiner.map(staff => ({
          user_id: staff.id,
          username: staff.staff_id_number,
          name: staff.staffname_kh1,
          position: staff.position_kh,
          image: staff.image,
          image_url: getImageUrl(staff.image),
          label: `${staff.staffname_kh1} | ${staff.position_kh}`,
        }));
        setUsers(userList);
        return userList;
      }
      return [];
    } catch (error) {
      console.log("Error loading users:", error);
      return [];
    } finally {
      setLoadingUsers(false);
    }
  };

  // Load approvers
  const loadApprovers = async (search = "") => {
    setLoadingApprovers(true);
    try {
      const param = new URLSearchParams({
        search: search,
        org_code: getProfile.org_code,
      });
      
      const res = await request(`lettersjoiner?${param.toString()}`, "get", {});
      
      if (res && res.api_server_list_joiner) {
        const approverList = res.api_server_list_joiner.map(staff => ({
          user_id: staff.id,
          username: staff.staff_id_number,
          name: staff.staffname_kh1,
          position: staff.position_kh,
          image: staff.image,
          image_url: getImageUrl(staff.image),
          label: `${staff.staffname_kh1} | ${staff.position_kh}`,
        }));
        setApprovers(approverList);
        return approverList;
      }
      return [];
    } catch (error) {
      console.log("Error loading approvers:", error);
      return [];
    } finally {
      setLoadingApprovers(false);
    }
  };

  // Debounced search for users
  const handleUserSearch = useRef(
    debounce((value) => {
      loadUsers(value);
    }, 300)
  ).current;

  // Debounced search for approvers
  const handleApproverSearch = useRef(
    debounce((value) => {
      loadApprovers(value);
    }, 300)
  ).current;

  // Handle delete
  const handleDelete = async (item, type) => {
    setLoadingSpin(true);
    try {
      const endpoint = type === "hierarchy" 
        ? `approval-hierarchy/${item.id}`
        : `approval-route-exceptions/${item.id}`;
      
      const res = await request(endpoint, "DELETE", {});
      
      if (res && res.isOk === true) {
        message.success("លុបបានជោគជ័យ");
        if (type === "hierarchy") {
          getHierarchyList();
        } else {
          getExceptionList();
        }
      } else {
        message.error(res?.message || "លុបមិនបានសម្រេច");
      }
    } catch (error) {
      console.error("Error while deleting:", error);
      message.error("មានបញ្ហាក្នុងការលុប");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Handle toggle status
  const handleToggleStatus = async (item, type) => {
    setLoadingSpin(true);
    try {
      const endpoint = type === "hierarchy" 
        ? `approval-hierarchy/${item.id}/toggle-status`
        : `approval-route-exceptions/${item.id}/toggle-status`;
      
      const res = await request(endpoint, "PATCH", {});
      
      if (res && res.isOk === true) {
        message.success("បានផ្លាស់ប្តូរស្ថានភាព");
        if (type === "hierarchy") {
          getHierarchyList();
        } else {
          getExceptionList();
        }
      } else {
        message.error(res?.message || "មានបញ្ហា");
      }
    } catch (error) {
      console.error("Error while toggling status:", error);
      message.error("មានបញ្ហា");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Open add modal
  const handleAddNew = async (type) => {
    setModalType(type);
    setEditingId(null);
    setEditInitialData(null);
    form.resetFields();
    form.setFieldsValue({ 
      is_active: true,
      approval_level: 1,
    });
    setLoadingModalOpen(true);
    
    try {
      await loadDepartments();
      if (type === "exception") {
        await loadUsers();
      }
      await loadApprovers();
      setIsModalVisible(true);
    } catch (error) {
      console.log("Error opening modal:", error);
      message.error("មិនអាចបើកទម្រង់បានទេ");
    } finally {
      setLoadingModalOpen(false);
    }
  };

  // Open edit modal - COMPLETELY FIXED
  const handleEdit = async (item, type) => {
    console.log("Editing item:", item, "Type:", type);
    setModalType(type);
    setEditingId(item.id);
    setLoadingModalOpen(true);
    
    try {
      // Load all data first
      await loadDepartments();
      
      // Prepare initial data
      const initialData = {
        is_active: item.is_active === 1,
        approval_level: item.approval_level,
      };
      
      if (type === "exception") {
        // Load users and approvers
        const userList = await loadUsers();
        const approverList = await loadApprovers();
        
        // Check if the user exists in the loaded list
        const userExists = userList.find(u => u.user_id === item.user_id);
        const approverExists = approverList.find(a => a.user_id === item.approver_user_id);
        
        // If user doesn't exist in the list, add it manually
        if (!userExists && item.user_id) {
          const newUser = {
            user_id: item.user_id,
            username: item.user_username || "",
            name: item.user_name || "Unknown User",
            position: item.user_position || "",
            image: item.user_image,
            image_url: getImageUrl(item.user_image),
            label: `${item.user_name || "Unknown User"} | ${item.user_position || ""}`,
          };
          setUsers(prev => [newUser, ...prev]);
        }
        
        // If approver doesn't exist in the list, add it manually
        if (!approverExists && item.approver_user_id) {
          const newApprover = {
            user_id: item.approver_user_id,
            username: item.approver_username || "",
            name: item.approver_name || "Unknown Approver",
            position: item.approver_position || "",
            image: item.approver_image,
            image_url: getImageUrl(item.approver_image),
            label: `${item.approver_name || "Unknown Approver"} | ${item.approver_position || ""}`,
          };
          setApprovers(prev => [newApprover, ...prev]);
        }
        
        initialData.user_id = item.user_id;
        initialData.approver_user_id = item.approver_user_id;
      } else {
        // For hierarchy
        const approverList = await loadApprovers();
        
        const approverExists = approverList.find(a => a.user_id === item.approver_user_id);
        
        if (!approverExists && item.approver_user_id) {
          const newApprover = {
            user_id: item.approver_user_id,
            username: item.approver_username || "",
            name: item.approver_name || "Unknown Approver",
            position: item.position_kh || item.approver_position || "",
            image: item.approver_image,
            image_url: getImageUrl(item.approver_image),
            label: `${item.approver_name || "Unknown Approver"} | ${item.position_kh || item.approver_position || ""}`,
          };
          setApprovers(prev => [newApprover, ...prev]);
        }
        
        initialData.department_code = item.department_code || null;
        initialData.approver_user_id = item.approver_user_id;
      }
      
      // Store initial data and set form values
      setEditInitialData(initialData);
      
      // Use setTimeout to ensure state updates are complete
      setTimeout(() => {
        form.setFieldsValue(initialData);
      }, 100);
      
      setIsModalVisible(true);
    } catch (error) {
      console.log("Error opening edit modal:", error);
      message.error("មិនអាចបើកទម្រង់កែប្រែបានទេ");
    } finally {
      setLoadingModalOpen(false);
    }
  };

  // Handle modal submit
  const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();
      console.log("Form values:", values);
      
      let endpoint, method, submitData;
      
      if (modalType === "hierarchy") {
        endpoint = editingId 
          ? `approval-hierarchy/${editingId}`
          : "approval-hierarchy";
        method = editingId ? "PUT" : "POST";
        
        submitData = {
          org_code: getProfile.org_code,
          department_code: values.department_code || null,
          approver_user_id: values.approver_user_id,
          approval_level: values.approval_level || 1,
          is_active: values.is_active ? 1 : 0,
          usercreate: getProfile.fullname,
        };
      } else {
        endpoint = editingId 
          ? `approval-route-exceptions/${editingId}`
          : "approval-route-exceptions";
        method = editingId ? "PUT" : "POST";
        
        submitData = {
          org_code: getProfile.org_code,
          user_id: values.user_id,
          approver_user_id: values.approver_user_id,
          approval_level: values.approval_level || 1,
          is_active: values.is_active ? 1 : 0,
          usercreate: getProfile.fullname,
        };
      }

      console.log("Submitting:", endpoint, method, submitData);
      setLoadingSpin(true);
      
      const res = await request(endpoint, method, submitData);
      console.log("Submit response:", res);

      if (res && (res.isOk === true || res.success === true)) {
        message.success(editingId ? "កែប្រែបានជោគជ័យ" : "បង្កើតបានជោគជ័យ");
        setIsModalVisible(false);
        form.resetFields();
        setEditInitialData(null);
        
        if (modalType === "hierarchy") {
          getHierarchyList();
        } else {
          getExceptionList();
        }
      } else {
        throw new Error(res?.message || "មានបញ្ហាក្នុងការរក្សាទុក");
      }
    } catch (error) {
      console.error("Submit error:", error);
      message.error(error.message || "មានបញ្ហាក្នុងការរក្សាទុក");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Custom select option renderer
  const renderUserOption = (user) => {
    return (
      <Space>
        <Avatar 
          src={user.image_url}
          icon={!user.image_url && <UserOutlined />}
          size="medium"
        />
        <div>
          <div><strong>{user.name}</strong></div>
          <div style={{ fontSize: '12px', color: '#666' }}>{user.position}</div>
        </div>
      </Space>
    );
  };

  // Custom filter for Select to show label instead of value
  const filterOption = (input, option) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  };

  // Hierarchy table columns
  const hierarchyColumns = [
    {
      key: "id",
      title: "ល.រ",
      dataIndex: "id",
      width: 70,
    },
    {
      key: "department_name",
      title: "នាយកដ្ឋាន",
      dataIndex: "department_name",
      render: (value) => (
        <Tag color="blue">{value || "ទាំងអស់"}</Tag>
      ),
    },
    {
      key: "approver",
      title: "អ្នកអនុម័ត",
      render: (_, record) => {
        const imageUrl = getImageUrl(record.approver_image);
        return (
          <Space>
            <Avatar 
              src={imageUrl}
              icon={!imageUrl && <UserOutlined />}
              size="medium"
            />
            <div>
              <div><strong>{record.approver_name || "-"}</strong></div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {record.position_kh || record.approver_position || "-"}
              </div>
            </div>
          </Space>
        );
      },
    },
    {
      key: "approval_level",
      title: "កម្រិត",
      dataIndex: "approval_level",
      render: (value) => (
        <Tag color="green">កម្រិត {value}</Tag>
      ),
      width: 100,
    },
    {
      key: "is_active",
      title: "ស្ថានភាព",
      dataIndex: "is_active",
      render: (value) => (
        <Tag color={value === 1 ? "success" : "error"}>
          {value === 1 ? "សកម្ម" : "អសកម្ម"}
        </Tag>
      ),
      width: 100,
    },
    {
      key: "created_at",
      title: "កាលបរិច្ឆេទ",
      dataIndex: "created_at",
      render: (value) => formateDateSystem(value),
      width: 150,
    },
    {
      key: "action",
      title: "សកម្មភាព",
      width: 180,
      render: (_, item) => (
        <Space>
          <Button
            icon={<EditFilled />}
            type="primary"
            onClick={() => handleEdit(item, "hierarchy")}
            size="small"
          />
          <Popconfirm
            title="បិទ/បើក"
            description="តើអ្នកចង់ផ្លាស់ប្តូរស្ថានភាពមែនទេ?"
            onConfirm={() => handleToggleStatus(item, "hierarchy")}
          >
            <Button
              icon={item.is_active === 1 ? <CloseOutlined /> : <ReloadOutlined />}
              style={{ 
                background: item.is_active === 1 ? "#faad14" : "#52c41a",
                borderColor: item.is_active === 1 ? "#faad14" : "#52c41a",
                color: "white"
              }}
              size="small"
            />
          </Popconfirm>
          <Popconfirm
            title="លុប"
            description="តើអ្នកប្រាកដថាចង់លុបមែនទេ?"
            onConfirm={() => handleDelete(item, "hierarchy")}
          >
            <Button danger type="primary" icon={<CloseOutlined />} size="small" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Exception table columns
  const exceptionColumns = [
    {
      key: "id",
      title: "ល.រ",
      dataIndex: "id",
      width: 70,
    },
    {
      key: "user",
      title: "អ្នកស្នើរសុំ",
      render: (_, record) => {
        const imageUrl = getImageUrl(record.user_image);
        return (
          <Space>
            <Avatar 
              src={imageUrl}
              icon={!imageUrl && <UserOutlined />}
              size="medium"
            />
            <div>
              <div><strong>{record.user_name || "-"}</strong></div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {record.user_department || record.user_position || "-"}
              </div>
            </div>
          </Space>
        );
      },
    },
    {
      key: "approver",
      title: "អ្នកអនុម័ត",
      render: (_, record) => {
        const imageUrl = getImageUrl(record.approver_image);
        return (
          <Space>
            <Avatar 
              src={imageUrl}
              icon={!imageUrl && <UserOutlined />}
              size="medium"
            />
            <div>
              <div><strong>{record.approver_name || "-"}</strong></div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {record.approver_position || "-"}
              </div>
            </div>
          </Space>
        );
      },
    },
    {
      key: "approval_level",
      title: "កម្រិត",
      dataIndex: "approval_level",
      render: (value) => (
        <Tag color="green">កម្រិត {value}</Tag>
      ),
      width: 100,
    },
    {
      key: "is_active",
      title: "ស្ថានភាព",
      dataIndex: "is_active",
      render: (value) => (
        <Tag color={value === 1 ? "success" : "error"}>
          {value === 1 ? "សកម្ម" : "អសកម្ម"}
        </Tag>
      ),
      width: 100,
    },
    {
      key: "created_at",
      title: "កាលបរិច្ឆេទ",
      dataIndex: "created_at",
      render: (value) => formateDateSystem(value),
      width: 150,
    },
    {
      key: "action",
      title: "សកម្មភាព",
      width: 180,
      render: (_, item) => (
        <Space>
          <Button
            icon={<EditFilled />}
            type="primary"
            onClick={() => handleEdit(item, "exception")}
            size="small"
          />
          <Popconfirm
            title="បិទ/បើក"
            description="តើអ្នកចង់ផ្លាស់ប្តូរស្ថានភាពមែនទេ?"
            onConfirm={() => handleToggleStatus(item, "exception")}
          >
            <Button
              icon={item.is_active === 1 ? <CloseOutlined /> : <ReloadOutlined />}
              style={{ 
                background: item.is_active === 1 ? "#faad14" : "#52c41a",
                borderColor: item.is_active === 1 ? "#faad14" : "#52c41a",
                color: "white"
              }}
              size="small"
            />
          </Popconfirm>
          <Popconfirm
            title="លុប"
            description="តើអ្នកប្រាកដថាចង់លុបមែនទេ?"
            onConfirm={() => handleDelete(item, "exception")}
          >
            <Button danger type="primary" icon={<CloseOutlined />} size="small" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {loadingSpin && (
        <div className="sprinSave-container">
          <div className="sprinSave">
            <GetLoading />
          </div>
        </div>
      )}
      {loading && (
        <div className="table-fullscreen-loader">
          <GetLoading />
        </div>
      )}

      <div style={boxHeader}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px", width: "100%" }}>
          <Space>
            {boxHeaderTagText("ការគ្រប់គ្រង់ប្រព័ន្ធអនុម័ត")}
          </Space>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            <Input
              placeholder="ស្វែងរក..."
              prefix={<SearchOutlined />}
              value={txtSearch}
              onChange={(e) => {
                setTxtSearch(e.target.value);
                setFilterParam(prev => ({ ...prev, search: e.target.value }));
              }}
              allowClear
              style={{ width: 250 }}
            />
            <Select
              value={filterParam.status}
              onChange={(status) => setFilterParam(prev => ({ ...prev, status }))}
              style={{ width: 150 }}
              placeholder="ស្ថានភាព"
            >
              <Option value="all">ទាំងអស់</Option>
              <Option value="active">សកម្ម</Option>
              <Option value="inactive">អសកម្ម</Option>
            </Select>
            <Button
              className="buttonstylekhmer"
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={() => handleAddNew(activeTab)}
            >
              បង្កើតថ្មី
            </Button>
          </div>
        </div>
      </div>

      <Tabs 
        activeKey={activeTab} 
        onChange={(key) => {
          setActiveTab(key);
          setFilterParam({ search: "", status: "all" });
          setTxtSearch("");
        }}
        style={{ marginTop: 16 }}
      >
        <TabPane 
          tab={
            <span>
              <ApartmentOutlined />
              ឋានានុក្រមអ្នកអនុម័ត ({hierarchyList.length})
            </span>
          } 
          key="hierarchy"
        >
          <Table
            pagination={{
              pageSize: 10,
              showTotal: (total) => `សរុប ${total}`,
            }}
            columns={hierarchyColumns}
            size="small"
            dataSource={hierarchyList}
            rowKey="id"
            loading={{ spinning: loading, indicator: <div /> }}
            locale={{ emptyText: "មិនមានទិន្នន័យ" }}
          />
        </TabPane>
        
        <TabPane 
          tab={
            <span>
              <BranchesOutlined />
              ករណីលើកលែង ({exceptionList.length})
            </span>
          } 
          key="exception"
        >
          <Table
            pagination={{
              pageSize: 10,
              showTotal: (total) => `សរុប ${total}`,
            }}
            columns={exceptionColumns}
            size="small"
            dataSource={exceptionList}
            rowKey="id"
            loading={{ spinning: loading, indicator: <div /> }}
            locale={{ emptyText: "មិនមានទិន្នន័យ" }}
          />
        </TabPane>
      </Tabs>

      <Modal
        title={
          modalType === "hierarchy"
            ? (editingId ? "កែប្រែឋានានុក្រម" : "បង្កើតឋានានុក្រមថ្មី")
            : (editingId ? "កែប្រែករណីលើកលែង" : "បង្កើតករណីលើកលែងថ្មី")
        }
        open={isModalVisible}
        onOk={handleModalSubmit}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
          setEditingId(null);
          setEditInitialData(null);
        }}
        width={600}
        okText={editingId ? "រក្សាទុក" : "បង្កើត"}
        cancelText="បោះបង់"
        confirmLoading={loadingSpin}
        destroyOnClose
      >
        <Spin spinning={loadingModalOpen} tip="កំពុងផ្ទុក..." indicator={<GetLoading />}>
          <Form 
            form={form} 
            layout="vertical" 
            style={{ marginTop: 20 }}
            initialValues={editInitialData}
          >
            {modalType === "exception" && (
              <Form.Item
                name="user_id"
                label="អ្នកស្នើរសុំ"
                rules={[{ required: true, message: "សូមជ្រើសរើសអ្នកស្នើរសុំ" }]}
              >
                <Select
                  placeholder="ជ្រើសរើសអ្នកស្នើរសុំ"
                  showSearch
                  size="large"
                  loading={loadingUsers}
                  onSearch={handleUserSearch}
                  filterOption={filterOption}
                  notFoundContent={loadingUsers ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                  optionLabelProp="label"
                >
                  {users.map((user) => (
                    <Option 
                      key={user.user_id} 
                      value={user.user_id}
                      label={user.label}
                    >
                      {renderUserOption(user)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            {modalType === "hierarchy" && (
              <Form.Item
                name="department_code"
                label="នាយកដ្ឋាន (ទុកទទេសម្រាប់ទាំងអស់)"
              >
                <Select
                  placeholder="ជ្រើសរើសនាយកដ្ឋាន (ជម្រើស)"
                  showSearch
                  size="large"
                  loading={loadingDepartments}
                  allowClear
                  optionFilterProp="children"
                  notFoundContent={loadingDepartments ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                >
                  {departments.map((dept) => (
                    <Option key={dept.code} value={dept.code}>
                      {dept.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Form.Item
              name="approver_user_id"
              label="អ្នកអនុម័ត"
              rules={[{ required: true, message: "សូមជ្រើសរើសអ្នកអនុម័ត" }]}
            >
              <Select
                placeholder="ជ្រើសរើសអ្នកអនុម័ត"
                showSearch
                size="large"
                loading={loadingApprovers}
                onSearch={handleApproverSearch}
                filterOption={filterOption}
                notFoundContent={loadingApprovers ? <Spin size="small" /> : "មិនមានទិន្នន័យ"}
                optionLabelProp="label"
              >
                {approvers.map((approver) => (
                  <Option 
                    key={approver.user_id} 
                    value={approver.user_id}
                    label={approver.label}
                  >
                    {renderUserOption(approver)}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="approval_level"
              label="កម្រិតអនុម័ត"
              rules={[{ required: true, message: "សូមបញ្ចូលកម្រិត" }]}
            >
              <InputNumber 
                min={1} 
                max={10} 
                style={{ width: "100%" }} 
                placeholder="កម្រិតអនុម័ត (1-10)"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="is_active"
              label="ស្ថានភាព"
              valuePropName="checked"
            >
              <Switch
                checkedChildren="សកម្ម"
                unCheckedChildren="អសកម្ម"
                defaultChecked={true}
              />
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default ApprovalHierarchyManagement;